import React from 'react';
import { HUBSPOT_FORM_SOURCE } from '/src/lib/constants';
import { PUBLIC_IMG_URL } from '/src/lib/endpoints';

import LandingPageComponent from './components/LandingPageComponent';

const StartupDirectoryLanding = (props) => {

    const contactFormConfig = {
        contactSalesPage: HUBSPOT_FORM_SOURCE.startups_dir_locked_section
    };

    const customFeaturesData = ({ totalStartups }) => [
        {
            id: 'startups',
            title: 'Explore the Startup Landscape at a Glance',
            description: ` From early-stage innovators to market leaders, our startup directory contains over ${totalStartups} companies, with detailed, verified data on their funding history and growth trajectory, all in one place.`,
            image: `${PUBLIC_IMG_URL}/directory-landing/startups-directory.webp`,
            altText: 'Startup Directory Feature',
            buttonText: `Speak to our Team`,
        },
        {
            id: 'filtering-search',
            title: 'Find Exactly What You’re Looking For',
            description: `Narrow your search with powerful filters across industry, location, funding stage, and more. Whether you’re scouting for the next unicorn or mapping the competitive landscape, the right startups are just a few clicks away.`,
            image: `${PUBLIC_IMG_URL}/directory-landing/filter-search.webp`,
            altText: 'Filtering and Search Feature',
            buttonText: `Book a Demo`,
        }
    ];

    const customPageMetadata = ({ totalStartups }) => ({
        pageTitle: 'Startups Directory Landing Page',
        title: `Your Access Point to ${totalStartups} Startups in Emerging Markets`,
        description: "Discover verified startup data, track funding activity and uncover emerging trends. From early-stage innovators to regional success stories, track the next wave of innovation.",
        url: '/startups',
        componentName: 'StartupsDirectoryLanding',
        landingPageType: 'Startups',
        amplitudeEvent: 'Clicked Contact Sales from Startup Directory Landing Page',
        heroButtonText: 'Learn More',
    });

    return (
        <LandingPageComponent
            contactFormConfig={contactFormConfig}
            customFeaturesData={customFeaturesData}
            customPageMetadata={customPageMetadata}
            className="startup-directory-landing-container"
            showVideoSection={false}
            location={props.locationSearch}
        />
    );
};

export default StartupDirectoryLanding;
